export default __webpack_public_path__ + "static/media/IC6_Blue.920f2330.png";